import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { BottomNav } from './BottomNav'
import { TopBar } from './TopBar'
import { AIAssistantBubble } from '@/components/shared/AIAssistantBubble'
import { OfflineBanner } from '@/components/shared/OfflineBanner'
import { ErrorBoundary } from '@/components/shared/ErrorBoundary'

const pageTitles: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/products': 'Products',
  '/orders': 'Orders',
  '/customers': 'Customers',
  '/wizard': 'Setup Wizard',
  '/content': 'Content Generator',
  '/content-library': 'Content Library',
  '/research': 'Competitor Research',
  '/va-guide': 'VA Guide',
  '/settings': 'Settings',
  '/admin': 'Admin Panel',
}

export function AppLayout() {
  const location = useLocation()
  const title = pageTitles[location.pathname] ??
    Object.entries(pageTitles).find(([path]) => location.pathname.startsWith(path))?.[1]

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <Sidebar />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <OfflineBanner />
        <TopBar title={title} />

        <main className="flex-1 overflow-y-auto pb-20 md:pb-0">
          <div className="max-w-7xl mx-auto p-4 md:p-6">
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </div>
        </main>
      </div>

      <BottomNav />
      <AIAssistantBubble />
    </div>
  )
}
